import { render } from "./ReferralAddressForm.vue?vue&type=template&id=0aa92a50&ts=true"
import script from "./ReferralAddressForm.ts?vue&type=script&lang=ts&external"
export * from "./ReferralAddressForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__